import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { InputContainerModule } from '../input-container/input-container.module';
import { InteractiveTableComponent } from './interactive-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextInputModule } from '../text-input/text-input.module';
import { TablePaginationPipe } from './table-pagination.pipe';
import { ButtonModule } from '../../button/button.module';
import { ModalModule } from '../../modal/modal.module';
import localeSv from '@angular/common/locales/sv';
import { TranslocoModule } from '@ngneat/transloco';
import { IconModule } from '../../icon/icon.module';
import { TooltipModule } from '../../tooltip/tooltip.module';
import { NumberFormatPipe } from '../../../pipes/number-format.pipe';
import { TableColspanPaginationPipe } from './table-colspan-pagination.pipe';
import { ToggleModule } from '../../toggle/toggle.module';
import { FeedbackMessageComponent } from '../../feedback-message/feedback-message.component';
registerLocaleData(localeSv);

@NgModule({
  declarations: [
    InteractiveTableComponent,
    NumberFormatPipe,
    TablePaginationPipe,
    TableColspanPaginationPipe,
  ],
  imports: [
    CommonModule,
    InputContainerModule,
    TextInputModule,
    FormsModule,
    ReactiveFormsModule,
    IconModule,
    ButtonModule,
    ModalModule,
    TranslocoModule,
    TooltipModule,
    ToggleModule,
    FeedbackMessageComponent,
  ],
  exports: [InputContainerModule, InteractiveTableComponent, NumberFormatPipe],
})
export class InteractiveTableModule {}
